import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StaticService } from '../../_services/static.service';
import { GtmService, UserService } from 'src/app/_services';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  info: any;
  isAuth: boolean = true;
  loggedInUserData: any;

  constructor(private router: Router, private _SS: StaticService, private _US: UserService, private gtmService: GtmService) { }

  ngOnInit(): void {
    this.getContactInfo();
    this._US.getAuth().subscribe(
      (data: any) => {
        this.isAuth = data;
      }
    )
    this._US.getUser().subscribe(
      (data: any) => {
        this.loggedInUserData = data;
      }
    )
  }

  redirectToPropertyListing(searchKey: string) {
    window.scrollTo(0, 0);
    let formattedSentence = searchKey.replace(/[\s,]+/g, '-').toLowerCase();
    this.router.navigate([`${formattedSentence?'/buy-properties-in-'+formattedSentence:''}`], {
      state: {
        searchKey: searchKey
      }
    });
  sessionStorage.setItem('propertyState', JSON.stringify({
    searchKey: searchKey
  }));
    const loginEventData = {
      'event': 'navigation_interaction',
      'click_header': 'Popular Searches',
      'click_subheader': searchKey,
      'click_location': 'footer',
      'userID': this.isAuth ? this.loggedInUserData.userId : '',
      'user_status': this.isAuth ? 'loggedin' : 'Nonloggedin' // Nonloggedin.
    }
    this.gtmService.pushDataToDataLayer(loginEventData);
  }

  getContactInfo() {
    this._SS.getContactInfo().subscribe(
      (data: any) => {
        if (data.meta.status) {
          this.info = data.data;
          this._SS.updateInfo(this.info);
        }
      }
    )
  }

  scrollUp(name: string,subName:string) {
    window.scrollTo(0, 0);
    this.ctaClickEvent(name,subName);
  }

  ctaClickEvent(name: string, subName: string) {
    const loginEventData = {
      'event': 'navigation_interaction',
      'click_header': name,
      'click_subheader': subName,
      'click_location': 'footer',
      'userID': this.isAuth ? this.loggedInUserData.userId : '',
      'user_status': this.isAuth ? 'loggedin' : 'Nonloggedin' // Nonloggedin.
    }
    this.gtmService.pushDataToDataLayer(loginEventData);
  }

  ctaClickEventApp(key: string) {
    const loginEventData = {
      'event': 'cta_click',
      'click_category': 'App Download',
      'click_text': key,
      'click_location': 'footer',
      'userID': this.isAuth ? this.loggedInUserData.userId : '',
      'user_status': this.isAuth ? 'loggedin' : 'Nonloggedin' // Nonloggedin.
    }
    this.gtmService.pushDataToDataLayer(loginEventData);
  }

}